import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Button, Drawer, Form, Input, message, notification } from 'antd';
import React, { useEffect } from 'react';
import { PartnersService } from 'services/PartnersService';
import {
  CREATE_ERROR,
  EDIT_ERROR,
  REQUEST_LOADING,
  SUCCESS_CREATE,
  SUCCESS_UPDATE,
} from 'constants/alerts';
import { requiredRule } from 'utils/forms/validationRules';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';

function PartnersForm({ isActive, onClose, onSuccess, initialValues }) {
  const [form] = Form.useForm();
  const isEditing = initialValues !== null;

  useEffect(() => {
    if (initialValues) {
      const { title, username, code } = initialValues;

      form.setFieldsValue({
        title,
        username,
        code,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    if (values?.password !== values?.passwordConfirm) {
      notification.open({
        type: 'warning',
        message: 'Пароли должны совпадать',
      });
      return;
    }

    if (isEditing) {
      handleUpdate(values, initialValues.id);
    } else {
      handleCreate(values);
    }
  };

  const handleCreate = async (data) => {
    const hide = message.loading(REQUEST_LOADING);

    const { passwordConfirm, ...payload } = data;

    try {
      const isCreated = await PartnersService.createPartner(payload);

      if (isCreated) {
        handleConfirm();
        message.success(SUCCESS_CREATE);
      }
    } catch (err) {
      message.error(CREATE_ERROR);
    } finally {
      hide();
    }
  };

  const handleUpdate = async (data, id) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isUpdated = await PartnersService.updatePartner(data, id);

      if (isUpdated) {
        handleConfirm();
        message.success(SUCCESS_UPDATE);
      }
    } catch (err) {
      message.error(EDIT_ERROR);
    } finally {
      hide();
    }
  };

  const handleConfirm = () => {
    onClose();
    onSuccess();
    form.resetFields();
  };

  return (
    <Drawer
      title={isEditing ? 'Редактирование партнера' : 'Создание партнера'}
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
      >
        <Form.Item name="title" label="Наименование" rules={[requiredRule]}>
          <Input placeholder="Наименование партнера" allowClear />
        </Form.Item>

        <Form.Item
          name="username"
          label="Имя пользователя"
          rules={[requiredRule]}
        >
          <Input placeholder="Имя пользователя" allowClear />
        </Form.Item>

        <Form.Item name="code" label="Код" rules={[requiredRule]}>
          <Input placeholder="Код" allowClear />
        </Form.Item>

        {!isEditing && (
          <>
            <Form.Item
              name="password"
              label="Пароль"
              rules={[
                {
                  required: true,
                  message: 'Обязательное поле',
                },
              ]}
            >
              <Input.Password
                allowClear
                placeholder="Введите пароль"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <Form.Item
              name="passwordConfirm"
              label="Повторите пароль"
              rules={[
                {
                  required: true,
                  message: 'Обязательное поле',
                },
              ]}
            >
              <Input.Password
                allowClear
                placeholder="Введите пароль"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
          </>
        )}

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { PartnersForm };
